import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 border-t border-slate-800 text-white py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col items-center">
          {/* Copyright */}
          <div className="text-center text-sm text-slate-400">
            <p>© {currentYear} Mikołaj Wójtowicz</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
